import React from 'react';
import Menu from '../nav/menu';
import Footer from '../nav/footer';
import Button from '@mui/material/Button';
import CoffeComponent from '../components/coffee';
import CarroucelMain from '../components/carroucelMain';
import StylishHeader from '../components/stylishHeader';
import SpecialtyCoffeMain from '../components/specialtyCoffee';
import OurFarmsComponent from '../components/ourFamrsComponents.js';
import OurProvidersList from '../components/ListOurProviders.js';
import { 
    headerText,
    bodyText,
    buttonText,
    buttonTextSubscribe,
    bodySubscribeMovil
 } from './styles';
import { Link } from 'react-router-dom';

function MainPageMobile(props) {
    /* eslint-disable react/prop-types */
    const isLargeScreen = props.isLargeScreen;
    const isSmallScreen = props.isSmallScreen;
    return (
        <div style={{ backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat" }}>
            <Menu/>
            <div style={{ background: "#FFFFFF" }}>
                <img src="/img/hombreTrabadorDeCafe.jpg" width="100%" alt="" />
                <div id="firstDiv" style={{ padding: "10px" }}>
                    <h1>{headerText}</h1>
                    <p style={{fontSize: "x-large"}}>{bodyText}</p>
                    <div>
                        <Button variant="contained" sx={{ width: "100%", borderRadius: "30px", backgroundColor: "#8C6E63", color: "black" }} >{buttonText}</Button>
                    </div>
                </div>
            </div>
            <div style={{ background: "#FFFFFF", margin: "5px", borderWidth: "2px", borderStyle: "solid", borderRadius: "30px" }}>
                <div style={{ padding: "10px" }}>
                    <span style={{ fontSize: "xx-large", display: "flow", width: "100%", textAlign: "justify" }}>{bodySubscribeMovil}</span>
                    <div>
                        <Link to="/newsletter">
                            <Button variant="contained" sx={{ width: "100%", borderRadius: "30px", backgroundColor: "#8C6E63", color: "black" }} >{buttonTextSubscribe}</Button>
                        </Link>
                    </div>
                </div>
            </div>
            <StylishHeader headerText="More about us" />
            <CarroucelMain/>
            <SpecialtyCoffeMain isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
            <OurProvidersList isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
            <StylishHeader headerText="Our type of toast" />
            <CoffeComponent/>
            <OurFarmsComponent isLargeScreenisLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} />
            <Footer />
        </div>
    )

}
export default MainPageMobile;